













import { Vue, Component, Prop } from 'vue-property-decorator';
import FieldSettingsContainer from '@/dealroom/fields/context-menu/components/FieldSettingsContainer.vue';
import Button from '@/components/Button.vue';
import { EButtonTypes } from '@/enums/ButtonType';

@Component({
  components: {
    Button,
    FieldSettingsContainer,
  },
})
export default class FieldDuplicate extends Vue {
  @Prop() height: string;
  EButtonTypes = EButtonTypes;

  handleDuplicate() {
    this.$emit('duplicate');
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleDuplicate();
    }
  }

  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}
